import { render, staticRenderFns } from "./ReactNestableRow.vue?vue&type=template&id=5edd08ba&scoped=true&"
import script from "./ReactNestableRow.vue?vue&type=script&lang=js&"
export * from "./ReactNestableRow.vue?vue&type=script&lang=js&"
import style0 from "./ReactNestableRow.vue?vue&type=style&index=0&id=5edd08ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd08ba",
  null
  
)

export default component.exports